import { Link } from "react-router-dom";

const a = "hover:text-cyan-300 transition-colors duration-200";

export const Footer = ({ compact = false }) => (
  <footer data-testid="footer-global" className={`${compact ? "py-1.5" : "py-3 border-t border-cyan-500/10"} px-4 text-center text-[11px] text-slate-500 font-mono whitespace-nowrap overflow-hidden text-ellipsis`}>
    <a href="https://www.graficawebdesign.com" target="_blank" rel="noopener noreferrer" data-testid="footer-copyright-link" className={a}>© {new Date().getFullYear()} GWD · Pixaweb sagl</a>
    {" · "}<Link to="/termini-e-condizioni" className={a} data-testid="footer-terms-link">Termini</Link>
    {" · "}<Link to="/privacy-policy" className={a} data-testid="footer-privacy-link">Privacy</Link>
    {" · "}<a href="mailto:info@graficawebdesign.com" data-testid="footer-email-link" className={a}>Contatti</a>
  </footer>
);
